<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Comment - {{ticketId}}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>Previous Comments:</v-card-text>

      <v-card flat style="padding:15px;overflow-y:auto;height:300px;background-color:#F5F5F5;">
        <Comment
          v-for="(item, index) in comments"
          :author="item.authorUsername"
          :time="item.createdAt"
          :text="item.text"
          :key="item.id"
        >
        </Comment>
        <div
          v-if="comments && comments.length === 0"
          class="pa-3"
          style="background-color: black; color: white; text-align: center;"
        >
          NO COMMENTS
        </div>
      </v-card>

      <v-card-text>
        <v-textarea
          v-model="commentText"
          outlined
          rows="3"
          label="New comment text"
        >
        </v-textarea>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="amber" @click="onSaveClick()">Save</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Comment from './Comment.vue';

export default {
  components: {
    Comment,
  },

  props: {
    dialog: Boolean,
    ticketId: String,
    comments: Array,
  },

  data() {
    return {
      commentText: '',
    };
  },

  methods: {
    onSaveClick() {
      this.$emit('close', { text: this.commentText });
      this.commentText = '';
    },

    onCancelClick() {
      this.$emit('close', { text: null });
      this.commentText = '';
    },
  },
};
</script>
